import axios from 'axios'

export interface ArticleCategory {
  ID_KATEGORI: number
  KATEGORI: string
  SLUG: string
  ID_INDUK: number | null
  STATUS_AKTIF: number
  META_TITLE?: string
  META_DESC?: string
  CONTENT?: string
}

export interface Article {
  ID_ARTIKEL: number
  ID_KATEGORI: number
  JUDUL: string
  SLUG: string
  EXERPT: string
  CONTENT: string
  META_TITLE?: string
  META_KEYWORDS?: string
  META_DESC?: string
  OG_TITLE?: string
  OG_DESC?: string
  TWITTER_CARD?: string
  CANONICAL_URL?: string
  ROBOTS_META?: string
  FOCUS_KEYWORD?: string
  PUBLISHED_AT?: string
  GAMBAR?: string // JSON string array
  CREATED_AT?: string
  UPDATED_AT?: string
  NAMA_KATEGORI?: string
  SLUG_KATEGORI?: string
}

export interface FetchArticlesResponse {
  list: Article[]
  jumlahrecord: number
}

export const fetchActiveCategories = async (urlAPI: string): Promise<ArticleCategory[]> => {
  try {
    const response = await axios.get(`${urlAPI}ref/artikelkategoriselect`)
    if (response.status === 200 && response.data.metadata.code === 200) {
      return response.data.response || []
    }
  } catch (error) {
    console.error('Error fetching active categories:', error)
  }
  return []
}

export const fetchArticles = async (
  urlAPI: string,
  params: { nama?: string | null; id_kategori?: number | string | null; halaman?: number; baris?: number }
): Promise<FetchArticlesResponse> => {
  try {
    const response = await axios.post(`${urlAPI}ref/artikellist`, {
      nama: params.nama || null,
      id_kategori: params.id_kategori || null,
      halaman: params.halaman || 0,
      baris: params.baris || 9
    })

    if (response.status === 200 && response.data.metadata.code === 200) {
      return {
        list: response.data.response.list || [],
        jumlahrecord: response.data.metadata.jumlahrecord || 0
      }
    }
  } catch (error) {
    console.error('Error fetching articles list:', error)
  }
  return { list: [], jumlahrecord: 0 }
}

export const fetchArticleBySlug = async (urlAPI: string, slug: string): Promise<Article | null> => {
  try {
    const response = await axios.post(`${urlAPI}ref/detailartikel`, { slug })
    if (response.status === 200 && response.data.metadata.code === 200) {
      return response.data.response || null
    }
  } catch (error) {
    console.error('Error fetching article detail by slug:', error)
  }
  return null
}
